export default __webpack_public_path__ + "static/media/clock.0f86e842.svg";